import type { ApprovalStatus } from "@/api/ApprovalStatus";
import { ApprovedInhabitant } from "@/api/Approved";
import { CancelledInhabitant } from "@/api/Cancelled";
import { PendingInhabitant } from "@/api/Pending";
import { RejectedInhabitant } from "@/api/Rejected";

export const ApprovalStatusUtil = {
  isPending(status: ApprovalStatus): boolean {
    return status === PendingInhabitant || status === "pending";
  },
  isApproved(status: ApprovalStatus): boolean {
    return status === ApprovedInhabitant || status === "approved";
  },
  isCancelled(status: ApprovalStatus): boolean {
    return status === CancelledInhabitant || status === "cancelled";
  },
  isRejected(status: ApprovalStatus): boolean {
    return status === RejectedInhabitant || status === "rejected";
  },
  label(status: ApprovalStatus): string {
    if (ApprovalStatusUtil.isApproved(status)) return "Genehmigt";
    if (ApprovalStatusUtil.isRejected(status)) return "Abgelehnt";
    if (ApprovalStatusUtil.isCancelled(status)) return "Storniert";
    return "Offen";
  },
  color(status: ApprovalStatus): string {
    if (ApprovalStatusUtil.isApproved(status)) return "green";
    if (ApprovalStatusUtil.isRejected(status)) return "orange";
    if (ApprovalStatusUtil.isCancelled(status)) return "red";
    return "yellow";
  },
};
